export const updateUnsettledBadgePayment = (paymentData) => {
    if (paymentData?.unsettled_sums_with_currencies.length === 1) {
        $(document)
            .find('.badgePayment')
            .find('span')
            .text(
                `${i18next.t(
                    'filesSlice.action.fetchPayments.badgePayment.with_sum'
                )} ${numberFormatter.formatNumber(
                    paymentData?.unsettled_sums_with_currencies[0].total_sum
                )} ${paymentData?.unsettled_sums_with_currencies[0].short_code}`
            );
        $(document).find('.badgePayment').css({
            display: 'flex',
        });
    } else if (paymentData?.unsettled_sums_with_currencies.length > 1) {
        $(document)
            .find('.badgePayment')
            .find('span')
            .text(i18next.t('filesSlice.action.fetchPayments.badgePayment'));
        $(document).find('.badgePayment').css({
            display: 'flex',
        });
    } else {
        $(document).find('.badgePayment').hide();
    }
};
